import { t } from 'i18next'
import * as Yup from 'yup'
import { validId } from 'src/components/views/EscritosLexnet/components/shared/components/Intervinientes/components/Interviniente/types'
import { addressValidationSchema } from 'src/components/views/EscritosLexnet/components/shared/components/Intervinientes/components/forms/AddressForm'
import {
  checkTipoPersonaFisica,
  personaFisica
} from 'src/components/views/EscritosLexnet/components/shared/components/Intervinientes/components/types'
import { FormField } from 'src/enums/Form'
import { TipoPersona, TipoVia } from 'src/interfaces/Catalog'
import { emptyDireccion, RepresentanteLegal } from 'src/interfaces/EscritosLegales'

export const initialValues: RepresentanteLegal = {
  [FormField.INTERVINIENTE_PERSONA_TIPO]: personaFisica,
  [FormField.INTERVINIENTE_IDENTIFICACION_TIPO]: null,
  [FormField.INTERVINIENTE_IDENTIFICACION]: '',
  [FormField.INTERVINIENTE_NOMBRE]: '',
  [FormField.INTERVINIENTE_PRIMER_APELLIDO]: '',
  [FormField.INTERVINIENTE_SEGUNDO_APELLIDO]: '',
  [FormField.INTERVINIENTE_DIRECCION]: emptyDireccion
}

export const validationSchema = (tipoVias?: TipoVia[]): Yup.AnyObjectSchema => {
  return Yup.object().shape({
    [FormField.INTERVINIENTE_PERSONA_TIPO]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default')),
    [FormField.INTERVINIENTE_IDENTIFICACION_TIPO]: Yup.object()
      .nullable()
      .required(t('form.validation.required.default')),
    [FormField.INTERVINIENTE_IDENTIFICACION]: validId(),
    [FormField.INTERVINIENTE_NOMBRE]: Yup.string().required(t('form.validation.required.default')),
    [FormField.INTERVINIENTE_PRIMER_APELLIDO]: Yup.string().when(
      FormField.INTERVINIENTE_PERSONA_TIPO,
      {
        is: (tipoPersona: TipoPersona) => !checkTipoPersonaFisica(tipoPersona),
        then: Yup.string().required(t('form.validation.required.default'))
      }
    ),
    ...addressValidationSchema(tipoVias)
  })
}
